import axios from '../../axios'

/*
 * 角色管理模块
 */

// 新增保存
export const create = (data) => {
  return axios({
    url: '/berry-pub/billInfo/create',
    method: 'post',
    data
  })
}

// 编辑保存
export const updateByPrimaryKeySelective = (data) => {
  return axios({
    url: '/berry-pub/billInfo/update_by_primary_key_selective',
    method: 'post',
    data
  })
}

// 编辑保存
export const updateByPrimaryKey = (data) => {
  return axios({
    url: '/berry-pub/billInfo/update_by_primary_key',
    method: 'post',
    data
  })
}


// 删除
export const deleteByPrimaryKey = (data) => {
  return axios({
    url: '/berry-pub/billInfo/delete_by_primary_key',
    method: 'post',
    data
  })
}

// 主键查询
export const selectByPrimaryKey = (id) => {
  return axios({
    url: '/berry-pub/billInfo/select_by_primary_key',
    method: 'get',
    params:{id:id}
  })
}
// 主键扩展查询
export const selectWrapperByPrimaryKey = (id) => {
  return axios({
    url: '/berry-pub/billInfo/select_wrapper_by_primary_key',
    method: 'get',
    params:{id:id}
  })
}

// 分页查询
export const selectListPage = (data) => {
  return axios({
    url: '/berry-pub/billInfo/select_list_page',
    method: 'post',
    data
  })
}

// 分页列表查询
export const selectListWrapperPage = (data) => {
  return axios({
    url: '/berry-pub/billInfo/select_list_wrapper_page',
    method: 'post',
    data
  })
}

// 列表查询
export const selectList = (data) => {
  return axios({
    url: '/berry-pub/billInfo/select_list',
    method: 'post',
    data
  })
}

// 列表扩展查询
export const selectListWrapper = (data) => {
  return axios({
    url: '/berry-pub/billInfo/select_list_wrapper',
    method: 'post',
    data
  })
}

// 导出Excel用户信息
export const exportExcelFile = data => {
         return axios({
           url: "/berry-pub/billInfo/exportExcelFile",
           method: "post",
           data
         });
};
       

// 导出Excel用户信息
export const exportTempExcelFile = data => {
         return axios({
           url: "/berry-pub/billInfo/exportTempExcelFile",
           method: "get"
         });
       };


// WEBPACK FOOTER //
// ./src/http/modules/pub/billInfo.js